var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H3C1.35 0 0 1.35 0 3V27C0 28.65 1.35 30 3 30H27C28.65 30 30 28.65 30 27V3C30 1.35 28.65 0 27 0ZM9 25.5H4.5V12H9V25.5ZM6.75 9.45C5.25 9.45 4.05 8.25 4.05 6.75C4.05 5.25 5.25 4.05 6.75 4.05C8.25 4.05 9.45 5.25 9.45 6.75C9.45 8.25 8.25 9.45 6.75 9.45ZM25.5 25.5H21V17.55C21 16.3501 19.95 15.3 18.75 15.3C17.55 15.3 16.5 16.3501 16.5 17.55V25.5H12V12H16.5V13.8C17.25 12.6 18.9 11.7 20.25 11.7C23.1 11.7 25.5 14.1 25.5 16.95V25.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin02);
export default __webpack_public_path__ + "static/media/linkedin-02.c10d845e31107c88047fc557a8716e88.svg";
export { ForwardRef as ReactComponent };